import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { OnDemandResponse, OnDemandType } from './on-demand.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OnDemandService {
  private readonly apiUrl = '/api/OnDemand';

  constructor(private http: HttpClient) { }

  async fetchData(type: OnDemandType): Promise<OnDemandResponse> {
    const endpoint = type === 'mind' ? 'OnDemandWellbeing' : 'OnDemandBody';

    return await firstValueFrom(this.http.get<OnDemandResponse>(`${this.apiUrl}/${endpoint}`));
  }

  updateNote(type: OnDemandType, note: string): Observable<OnDemandResponse> {
    const endpoint = type === 'mind' ? 'ChangeWellbeingNote' : 'ChangeBodyNote';

    return this.http.post(`${this.apiUrl}/${endpoint}`, { note }, { observe: 'response' })
      .pipe(
        map(response => response.body as OnDemandResponse)
      );
  }

  bookOnDemand(type: OnDemandType): Observable<OnDemandResponse> {
    const endpoint = type === 'mind' ? 'BookWellbeingOnDemand' : 'BookBodyOnDemand';

    return this.http.post(`${this.apiUrl}/${endpoint}`, {}, { observe: 'response' })
      .pipe(
        map(response => response.body as OnDemandResponse)
      );
  }
}
